import { routesDef } from '../../config/routes'
import { useConfirmDialog, useHistory } from '@ztechapps/common.hook'
import { useUser } from '../../hooks/useUser'

export const useGotoCart = (orderId?: string): [() => Promise<void>, { loading: boolean; error: any }] => {
  orderId = orderId ?? ''

  const url = routesDef.CartPage.altPath({ orderId })
  const history = useHistory()
  const { loggedIn } = useUser()

  // const [orderSetStatusToInCart, , { loading, error }] = useChangeOrderStatus({
  //   options: {
  //     mutationOptions: {
  //       refetchQueries: ['orderGetCart'],
  //     },
  //   },
  // })
  // useError(error)

  const { confirm } = useConfirmDialog({
    text: `You need to login first to view your cart.`,
    title: 'Login first',
  })

  const gotoCart = async () => {
    //check if logged in, if not redirect to login first then to cart automatically,
    if (!loggedIn) {
      return await confirm(async () => history.push(routesDef.LoginPage.altPath({ redirect_url: url })))
    }

    //if there is specified orderId the
    // if (!isEmpty(orderId)) {
    //   await orderSetStatusToInCart({
    //     input: {
    //       filter: {
    //         _id: orderId,
    //       },
    //       targetState: OrderStatusEnum.InCart,
    //     },
    //   })
    // }

    return history.push(url)
  }

  return [gotoCart, { loading: false, error: null }]
}
